/* eslint-disable class-methods-use-this */

/**
 * This fixes an issue in Firefox where the image containers are 100% wide instead
 * of using the width of the image.
 *
 * @link https://www.bugherd.com/projects/184915/tasks/1541?assigned=rholmes%40emagine.com
 * @link https://www.bugherd.com/projects/184915/tasks/1735?assigned=rholmes%40emagine.com
 */

class ContentBackground {
	constructor(el) {
		this.el = el;

		this.updateWidths = this.updateWidths.bind(this);
		window.addEventListener('resize', this.updateWidths);
		window.addEventListener('orientationchange', this.updateWidths);

		this.bgInner = this.el.querySelector('.em-content-background__background-inner');
		if (this.bgInner) {
			this.bgImage = this.bgInner.querySelector('img');
			this.bgImage.addEventListener('emImageLoaded', this.updateWidths);
		}

		this.fgInner = this.el.querySelector('.em-content-background__foreground-inner');
		if (this.fgInner) {
			this.fgImage = this.fgInner.querySelector('img');
			this.fgImage.addEventListener('emImageLoaded', this.updateWidths);
		}
	}

	updateWidths() {
		window.requestAnimationFrame(() => {
			if (this.bgImage) {
				this.bgInner.style.width = `${this.bgImage.clientWidth}px`;
			}

			if (this.fgImage) {
				this.fgInner.style.width = `${this.fgImage.clientWidth}px`;
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.body.classList.contains('firefox')) {
		const contentBackgroundBlocks = Array.from(document.querySelectorAll('.em-content-background'));
		if (contentBackgroundBlocks) {
			contentBackgroundBlocks.map((block) => new ContentBackground(block));
		}
	}
});
